/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Tags_View_ClientsInputs */

const cs_clients_tags_view_clients = /** @type {(inputs: Clients_Tags_View_ClientsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zobrazit klienty`)
};

const en_clients_tags_view_clients = /** @type {(inputs: Clients_Tags_View_ClientsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View clients`)
};

/**
* | output |
* | --- |
* | "View clients" |
*
* @param {Clients_Tags_View_ClientsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const clients_tags_view_clients = /** @type {((inputs?: Clients_Tags_View_ClientsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Tags_View_ClientsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_tags_view_clients(inputs)
	return cs_clients_tags_view_clients(inputs)
});